module.exports = __webpack_public_path__ + "img/Span-06.88b2305d.jpg";